module.exports = __webpack_public_path__ + "static/media/1.7ac17422.jpg";